import type { ThemeConfig } from "antd";

import { GLOW_TOKENS } from "./tokens";

/**
 * Build the antd ThemeConfig for the Glow Price admin console.
 *
 * Returns a fresh object so callers can spread/override safely. All values
 * are derived from {@link GLOW_TOKENS}; do not hard-code palette values here.
 */
export function buildGlowTheme(): ThemeConfig {
  const { colors } = GLOW_TOKENS;

  return {
    token: {
      colorPrimary: colors.primary,
      colorPrimaryHover: colors.primaryHover,
      colorBgLayout: colors.bgLayout,
      colorBgContainer: colors.bgContainer,
      colorBorder: colors.border,
      colorBorderSecondary: colors.border,
      colorText: colors.textPrimary,
      colorTextSecondary: colors.textSecondary,
      colorTextTertiary: colors.textMuted,
      colorSuccess: colors.success,
      colorWarning: colors.warning,
      colorError: colors.error,
      colorLink: colors.primary,
      colorLinkHover: colors.primaryHover,
      fontFamily: GLOW_TOKENS.fontFamily,
      borderRadius: GLOW_TOKENS.borderRadius,
      borderRadiusLG: GLOW_TOKENS.borderRadiusLG,
      controlHeight: GLOW_TOKENS.controlHeight,
      boxShadow: GLOW_TOKENS.boxShadow,
      boxShadowSecondary: GLOW_TOKENS.boxShadowSecondary,
    },
    components: {
      Layout: {
        bodyBg: colors.bgLayout,
        headerBg: colors.bgContainer,
        headerColor: colors.textPrimary,
        headerHeight: 56,
        headerPadding: "0 20px",
        siderBg: colors.siderBg,
      },
      Menu: {
        darkItemBg: colors.siderBg,
        darkSubMenuItemBg: colors.siderBg,
        darkItemSelectedBg: colors.primary,
        darkItemSelectedColor: "#FFFFFF",
        darkItemHoverBg: colors.siderHoverBg,
        darkItemColor: colors.siderTextMuted,
        darkItemHoverColor: colors.siderText,
        darkGroupTitleColor: "rgba(245,245,245,0.38)",
        itemBorderRadius: 8,
        itemMarginInline: 8,
        itemHeight: 40,
      },
      Table: {
        headerBg: colors.tableHeaderBg,
        headerColor: colors.textSecondary,
        rowHoverBg: colors.tableRowHoverBg,
        headerSplitColor: "transparent",
        borderColor: colors.border,
        cellPaddingBlock: 12,
      },
      Tag: {
        borderRadiusSM: 6,
      },
      Card: {
        borderRadiusLG: 12,
      },
      Button: {
        fontWeight: 500,
        borderRadius: 8,
        controlHeight: 36,
        primaryShadow: "none",
        defaultShadow: "none",
      },
      Statistic: {
        titleFontSize: 13,
      },
    },
  };
}

export { GLOW_TOKENS } from "./tokens";
export default buildGlowTheme;
